import { Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from '@shared/models/user';

@Component({
  selector: 'app-user-selector-item',
  templateUrl: './user-selector-item.component.html',
  styleUrl: './user-selector-item.component.scss',
  standalone: false,
})
export class UserSelectorItemComponent {
  @Input() user: User;
  @Output() selectedUser = new EventEmitter<User>();
}
